import { AutoComplete } from "antd";
import classNames from "classnames";
import Label from "shared/components/Label";

const Component = ({ label, errors, icon, touched, required, ...rest }) => (
  <div
    className={classNames("autocomplete__wrapper", {
      __error: touched && errors,
    })}
  >
    <Label label={label} icon={icon} required={required} />
    <div className={`autocomplete__wrapper--field`}>
      <AutoComplete
        className={classNames({ "disable--input": rest.disabled })}
        {...rest}
      />
      {touched && errors && <p className={"input--errors"}>{errors}</p>}
    </div>
  </div>
);

export default Component;
